import { City } from "./weatherTypes.js";

export const Cities: City[] = [
  { name: "Toronto", id: "toronto" },
  { name: "Montreal", id: "montreal" },
  { name: "Longueuil", id: "longueuil" },
  { name: "Vancouver", id: "vancouver" },
  { name: "Calgary", id: "calgary" },
  { name: "Ottawa", id: "ottawa" },
  { name: "Edmonton", id: "edmonton" },
];
